import React from 'react';
import { Send } from 'lucide-react';

export const GerryInputBar = ({ input, setInput, onSend, quickActions }) => (
  <>
    {/* Quick actions */}
    <div className="px-3 pb-1 flex flex-wrap gap-1.5">
      {quickActions.map(q => (
        <button
          key={q}
          onClick={() => { setInput(q); setTimeout(() => { setInput(q); }, 0); }}
          className="text-[10px] px-2.5 py-1 rounded-full bg-gray-800 border border-gray-700 text-gray-400 hover:text-orange-400 hover:border-orange-500/50 transition-all"
        >
          {q}
        </button>
      ))}
    </div>

    {/* Input */}
    <div className="px-3 pb-3">
      <form
        onSubmit={(e) => { e.preventDefault(); onSend(); }}
        className="flex gap-2"
      >
        <input
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Ask Gerry anything..."
          className="flex-1 px-3 py-2 rounded-xl bg-gray-800/80 border border-gray-700 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-orange-500/50"
          data-testid="gerry-input"
        />
        <button
          type="submit"
          className="p-2 rounded-xl bg-gradient-to-r from-orange-500 to-amber-500 hover:opacity-90 transition-opacity"
          data-testid="gerry-send"
        >
          <Send className="w-4 h-4 text-black" />
        </button>
      </form>
    </div>
  </>
);
